const LegalHtmlPage = ({ src, title }: { src: string; title: string }) => {
	return <iframe src={src} title={title} style={{ width: '100%', minHeight: '100vh' }} />;
};

export const PrivacyKrPage = () => {
	return <LegalHtmlPage src="html/privacy-policy-kr.html" title="개인정보 수집 및 이용 동의" />;
};

export const PrivacyEnPage = () => {
	return <LegalHtmlPage src="html/privacy-policy-en.html" title="Privacy policy" />;
};

export const PrivacyJpPage = () => {
	return <LegalHtmlPage src="html/privacy-policy-jp.html" title="プライバシーポリシー" />;
};

export const PrivacyEsPage = () => {
	return <LegalHtmlPage src="html/privacy-policy-es.html" title="Política de privacidad" />;
};

export const PrivacyFrPage = () => {
	return <LegalHtmlPage src="html/privacy-policy-fr.html" title="Politique de confidentialité" />;
};

export const PrivacyRuPage = () => {
	return <LegalHtmlPage src="html/privacy-policy-ru.html" title="Политика конфиденциальности" />;
};
